export default __webpack_public_path__ + "255a9f0c4acd4648e643eedb61ea0c50.png";